import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck } from "@fortawesome/free-solid-svg-icons";

import { ShareArticleSection } from "../ShareArticleSection";

const DigitalConcierge = () => {
  return (
    <div className="modal-content-body case-studies-blk">
      <div className="modal-section">
        <div className="flex-content header-modal-case-studies">
          <div className="logo-section-modal">
            <img
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/thumbnails/kip-mcgrath-thumbnail-iris.png"
              alt="Kip Mccrath"
            />
          </div>
          <div>
            <h3>Amazon Connect Managed Service</h3>
            <p>
              Modernising education support with omnichannel communications, AI
              automation, and deep analytics.
            </p>
            <ShareArticleSection />
          </div>
        </div>
      </div>

      {/* Opportunity & Qualification */}
      <div className="modal-section">
        <h2 className="modal-section-title">Company Snapshot:</h2>
        <p className="title-description-blk">
          Kip McGrath is a renowned provider of personalised English and Maths
          tutoring, serving children aged 6-16+ through over 500 centres across
          Australia and abroad. With a mission to help every child reach their
          full potential, qualified tutors deliver in-centre and online lessons
          using proven, tailored instructional programs and ongoing assessment.
        </p>
      </div>

      {/* Proposed Solution */}
      <div className="modal-section">
        <div className="flex-content-half">
          <div>
            <h2 className="modal-section-title">Challenge:</h2>
            <p>
              Kip McGrath's growth and reputation for personalised support posed
              new demands on their service team. Existing systems could not
              unify customer interactions or scale easily, leaving the business
              without integrated chat channels, advanced reporting, or the
              ability to support round-the-clock student and parent needs across
              hundreds of centres
            </p>
          </div>
          <div>
            <h2 className="modal-section-title">AWS Solution:</h2>
            <p>
              iCXeed delivered an Amazon Connect managed service, seamlessly
              integrating emails from Outlook, launching a live chat channel,
              and implementing advanced dashboards and reporting with Amazon
              QuickSight. Amazon Q was rolled out for real-time agent assist,
              and Kip McGrath is transitioning towards full GenAI readiness with
              a 24/7 chatbot to serve families and tutors any time. Every centre
              can now access optimised voice, automated case management, unified
              customer profiles, and intelligent multi-channel support - all
              backed by managed service monitoring and remediation.
            </p>
          </div>
        </div>
      </div>

      <div className="outcomes-result-blk">
        <h2 className="modal-section-title">Outcomes/Results:</h2>
        <ul>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                True omnichannel communication: email, chat, and voice, all in
                one place.
              </p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                24/7 chatbot paves the way for scalable, AI-driven self-service.
              </p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                Real-time analytics, dashboards, and reporting support
                data-driven decision making.
              </p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                Enhanced customer profiles and case management for personalised
                support.
              </p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                Resilient and optimised voice infrastructure with proactive
                remediation and uplift.
              </p>
            </div>
          </li>
          <li>
            <div className="flex-box-blk">
              <FontAwesomeIcon icon={faCheck} color="#01C2F3" />
              <p>
                Consistent, measurable boost in support quality and centre
                efficiency across the network.
              </p>
            </div>
          </li>
        </ul>
      </div>

      <div className="modal-footnote use-cases-footnote" style={{ border: 0 }}>
        <h4>Client Testimonial</h4>
        <h1>
          "Our experience with iCXeed has been nothing short of outstanding.
          They've transformed how we work with customers, giving us the right
          balance of power, usability, and scalability. iCXeed has been more
          than a technology partner; they've been true collaborators who care
          deeply about driving the right outcomes."
        </h1>
        <div className="flex-box-blk client-details">
          <div>
            <img
              src="https://www.icxeed.ai/wp-content/themes/icxeed-website-2025/portal-assets/images/testimonials/emma-dent.png"
              alt="Emma Dent"
            />
          </div>
          <div>
            <h2>Emma Dent</h2>
            <p>Head of Corporate Operation</p>
            <p>Kip McGrath</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DigitalConcierge;
